import { render, staticRenderFns } from "./BrandResultInfoDetail.vue?vue&type=template&id=937bd638"
import script from "./BrandResultInfoDetail.vue?vue&type=script&lang=js"
export * from "./BrandResultInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./BrandResultInfoDetail.vue?vue&type=style&index=0&id=937bd638&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports